var female_first_name = require('./female_first_name');
var male_first_name = require('./male_first_name');
module.exports = female_first_name.concat(male_first_name);
